import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Logi sisse Google-iga

  <span style="color:#85c1dc;">**FI:**</span>
  Kirjaudu sisään

  <span style="color:#85c1dc;">**RU:**</span>
  Войти через Google
*/
/* @__NO_SIDE_EFFECTS__ */
const m624 = msg(
  mf`Logi sisse Google-iga`,
  mf`Kirjaudu sisään`,
  mf`Войти через Google`,
)

export { m624 as 'w.global.login-google' }